<template>
  <AbsPopup id="Notice" title="공지" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div>
          <UInput type="text" line="box" placeholder="공지를입력해주세요" align="left" v-model="message"/>
          <UInput type="text" line="box" placeholder="공지링크를입력해주세요" align="left" v-model="link"/>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.$emit('loading', false)
  },
  data: () => {
    return {
      message: ''
    }
  },
  name: 'Notice',
  computed: {
  },
  methods: {
    submit () {
      this.$http.post('/api/admin/user/notice', {message: this.message, link: this.link}).then((e) => {
        console.log(e)
        this.$emit('submit')
      })
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
.popup-body {
  width: 450px;
  padding: 20px;
}
.popup-body > div {
  line-height: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.popup-body > div:first-child > div:first-child {
  margin-right: auto;
}
.popup-body > div .input {
  width: 100%;
  height: 24px;
}
.inputPoint {
  border-bottom: 1px solid var(--line-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/Notice.vue